import React from 'react';
import { Linking } from 'react-native';
import { Box, Heading, Link, ScrollView, Text, VStack } from 'native-base';

export default function AccountDeletionPage() {
    const sendDeletionRequest = () => Linking.openURL(
        'mailto:grainiqinfo@gmail.com?subject=InstaGrainX%20Account%20Deletion%20Request&body=Please%20delete%20my%20InstaGrainX%20account.%0A%0AAccount%20username%20or%20email%3A%20'
    );
    const sendDataDeletionRequest = () => Linking.openURL(
        'mailto:grainiqinfo@gmail.com?subject=InstaGrainX%20Data%20Deletion%20Request&body=Please%20delete%20the%20following%20InstaGrainX%20data%20without%20deleting%20my%20account%3A%0A%0AAccount%20username%20or%20email%3A%20%0AData%20or%20job%20identifiers%3A%20'
    );

    return (
        <Box flex={1} bg="white" _dark={{ bg: 'gray.900' }}>
            <ScrollView>
                <VStack width="100%" maxWidth="760px" alignSelf="center" space={5} px={6} py={10}>
                    <Heading size="xl">Delete your InstaGrainX account</Heading>
                    <Text>
                        InstaGrainX users can request deletion from the app or by email. Before sending
                        a request, make sure you can access the email address associated with the account.
                    </Text>

                    <Heading size="md">Request deletion in the app</Heading>
                    <Text>
                        1. Sign in to InstaGrainX.{`\n`}
                        2. Open Settings.{`\n`}
                        3. Select Delete Account or Request Account Deletion.{`\n`}
                        4. Enter a reason if requested and submit the request.
                    </Text>

                    <Heading size="md">Request deletion by email</Heading>
                    <Text>
                        Email grainiqinfo@gmail.com from your account email address with the subject
                        "InstaGrainX Account Deletion Request" and include your username or account email.
                    </Text>
                    <Link onPress={sendDeletionRequest}>Email an account-deletion request</Link>

                    <Heading size="md">Delete selected data without deleting your account</Heading>
                    <Text>
                        You can delete individual jobs and their grain-analysis records in InstaGrainX.
                        You can also email grainiqinfo@gmail.com from your account email address with the
                        subject "InstaGrainX Data Deletion Request". Include your username or account
                        email and identify the jobs, sample images, reports, or other records you want
                        deleted. Your account will remain active unless you separately request account
                        deletion.
                    </Text>
                    <Link onPress={sendDataDeletionRequest}>Email a selected-data deletion request</Link>

                    <Heading size="md">What is deleted and what may be retained</Heading>
                    <Text>
                        After we verify the request, we delete or de-identify the account profile and
                        personal data linked to the account, including cloud-stored sample images and
                        grain-analysis records, unless retention is required by law, contract, security,
                        fraud-prevention, audit, or dispute-resolution obligations. Data retained for
                        those limited purposes is isolated from ordinary product use and deleted when the
                        applicable obligation ends. Backups are removed on their normal rotation schedule.
                    </Text>
                    <Text>
                        We aim to complete verified deletion requests within 30 days. We may contact you
                        for additional information needed to verify account ownership.
                    </Text>
                </VStack>
            </ScrollView>
        </Box>
    );
}
